export function loadSelfieSegmentationLibs(callback) {
  const libs = [
    "https://cdn.jsdelivr.net/npm/@mediapipe/camera_utils/camera_utils.js",
    "https://cdn.jsdelivr.net/npm/@mediapipe/control_utils/control_utils.js",
    "https://cdn.jsdelivr.net/npm/@mediapipe/drawing_utils/drawing_utils.js",
    "https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/selfie_segmentation.js",
  ];

  let loaded = 0;
  const oldDefine = window.define;
  const oldRequire = window.require;

  try {
    if (typeof window.requirejs !== "function" || !window.requirejs.s.contexts) {
      window.require = undefined;
      window.requirejs = undefined;
    }
    window.define = undefined;
  } catch (err) {
    console.warn("Protección AMD: no se pudo desactivar define correctamente", err);
  }

  const loadPromises = libs.map(
    (src) =>
      new Promise((resolve) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const s = document.createElement("script");
        s.src = src;
        s.async = false;
        s.onload = resolve;
        s.onerror = (err) => {
          console.warn("Error al cargar MediaPipe:", src, err);
          resolve(); // continúa aunque falle uno
        };

        try {
          document.head.appendChild(s);
        } catch (e) {
          console.warn("Error al inyectar script (sesión posiblemente finalizada)", e);
          resolve();
        }
      })
  );

  const finishLoad = () => {
    if (oldDefine) window.define = oldDefine;
    if (oldRequire) window.require = oldRequire;
  };

  const promise = Promise.all(loadPromises).then(() => {
    finishLoad();
    if (typeof callback === "function") {
      try {
        callback();
      } catch (e) {
        console.warn("Callback de MediaPipe cancelado (sesión posiblemente expirada)");
      }
    }
  });

  // Retorna la promesa para poder usar `await`
  return promise;
}
